export default "__VITE_ASSET__082P9E0R__"